import React from "react";
import { observer } from "mobx-react-lite";

export function memoObserver<P>(
  Component: React.FunctionComponent<P>
): React.MemoExoticComponent<React.FC<P>> {
  return React.memo(observer(Component));
}
